import { useRef, useState } from "react"

export function HorizontalPageLayout({ children, className = "", style,  }) {
    return (
        <div className={`horizontal complete-height body-screen ${className}`} style={style}>
            {children}
        </div>
    )
}

export function VerticalPageLayout({ children, className, style, scrollData = () => {} }) {
    return (
        <div onScroll={(event) => scrollData(event.target.scrollTop)} className={`vertical complete-height body-screen ${className}`} style={style}>
            {children}
        </div>
    )
}

export function HorizontalLayout({ children, className = "", style, onClick, onScroll= () => {} }) {
    return (
        <div onClick={onClick} className={`horizontal ${className}`} style={style} onScroll={onScroll}>
            {children}
        </div>
    )
}

export function VerticalLayout({ children, className = "", style, onClick }) {
    return (
        <div onClick={onClick} className={`vertical ${className}`} style={style}>
            {children}
        </div>
    )
}

export function GridLayout({ children, className = "", onClick, onChange, style, columnsTemplate = "", rowTemplate = "", gap = "0px" }) {
    return (
        <div onClick={onClick} className={className} onChange={onChange} style={{...style, "display": "grid", gap, "gridTemplateColumns": columnsTemplate, "gridTemplateRows": rowTemplate}}>
            {children}
        </div>
    )
}

export default function ScrollableLayout({ children, height = "23rem", className = "" }) {
  return (
    <VerticalLayout
      style={{
        maxHeight: height,
        overflowY: "auto",
        paddingRight: "1rem",
      }}
      className={className}
    >
      {children}
    </VerticalLayout>
  );
}
